import { render, staticRenderFns } from "./ResetPassword.view.vue?vue&type=template&id=09df33a2&"
import script from "./ResetPassword.view.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.view.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassword.view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports